export const ADD_PAYMENT_PROJECT_REQUEST = "FETCH_PAYMENT_PROJECT_REQUEST";
export const ADD_PAYMENT_PROJECT_SUCCESS = "FETCH_PAYMENT_PROJECT_SUCCESS";
export const ADD_PAYMENT_PROJECT_FAILURE = "FETCH_PAYMENT_PROJECT_FAILURE";
export const CLEAR_PAYMENT_PROJECTS_ERROR = "CLEAR_PAYMENT_PROJECTS_ERROR";
export const FETCH_PAYMENT_PROJECTS_REQUEST = "FETCH_PAYMENT_PROJECTS_REQUEST"; // Ensure this is added correctly
export const FETCH_PAYMENT_PROJECTS_SUCCESS = "FETCH_PAYMENT_PROJECTS_SUCCESS";
export const FETCH_PAYMENT_PROJECTS_FAILURE = "FETCH_PAYMENT_PROJECTS_FAILURE";
export const UPDATE_PAYMENT_PROJECTS_REQUEST =
  "UPDATE_PAYMENT_PROJECTS_REQUEST";
export const UPDATE_PAYMENT_PROJECTS_SUCCESS =
  "UPDATE_PAYMENT_PROJECTS_SUCCESS";
export const UPDATE_PAYMENT_PROJECTS_FAILURE =
  "UPDATE_PAYMENT_PROJECTS_FAILURE";
export const DELETE_PAYMENT_PROJECTS_REQUEST =
  "DELETE_PAYMENT_PROJECTS_REQUEST";
export const DELETE_PAYMENT_PROJECTS_SUCCESS =
  "DELETE_PAYMENT_PROJECTS_SUCCESS";
export const DELETE_PAYMENT_PROJECTS_FAILURE =
  "DELETE_PAYMENT_PROJECTS_FAILURE";
